import React, { useState } from 'react'
import { UnseatedEmployeeDrawer } from './UnseatedEmployeeDrawer'
import styles from './Drawer.module.scss'
import { Tooltip2 } from '@blueprintjs/popover2'
import { Position } from '@blueprintjs/core'
import { UseFloorHook } from '@providers/mapProvider/floorProvider/provider'
import { get } from 'lodash'
import DrawerBookingsList from 'components/AdminFloorPlan/DrawerBookingsList/DrawerBookingsList'
import { ISpace } from '@api'

const RightDrawer = ({
  assignmentPlanId,
  floor,
  setOpen,
  open,
  setSplitScreen,
  setShowFilters,
}: {
  assignmentPlanId: string
  floor: UseFloorHook
  setOpen: (open: boolean) => void
  open: boolean
  setSplitScreen: (value: boolean) => void
  setShowFilters: (value: boolean) => void
}) => {
  const spaces = floor.fetchSpaces?.()
  const toggleDrawer = () => {
    setOpen(!open)
    setSplitScreen(false)
    setShowFilters(false)
  }
  React.useEffect(() => {
    if (floor.isBookDeskPage) {
      setOpen(true)
    } else setOpen(false)
  }, [floor.isBookDeskPage, setOpen])

  const floorGeoLocationId = get(floor, 'map.building.geoLocation.id', undefined)
  const commonTooltip = (
    <>
      <Tooltip2
        className={styles.expandTooltip}
        content={open ? 'Collapse' : 'Expand'}
        placement={Position.LEFT}>
        <div className={styles.expandButton} onClick={toggleDrawer}>
          <i
            className={'far fa-chevron-right'}
            style={{
              transform: `rotate(${open ? 0 : 180}deg)`,
            }}
          />
        </div>
      </Tooltip2>
    </>
  )
  const spacesByIds = spaces && spaces['byId']
  return (
    <>
      {floor.isBookDeskPage ? (
        <DrawerBookingsList spaces={(spacesByIds || {}) as ISpace[]} open={open} floor={floor}>
          {commonTooltip}
        </DrawerBookingsList>
      ) : (
        <UnseatedEmployeeDrawer
          open={open}
          assignmentPlanId={assignmentPlanId}
          floorGeoLocationId={floorGeoLocationId}
          floor={floor}>
          {commonTooltip}
        </UnseatedEmployeeDrawer>
      )}
    </>
  )
}

export default RightDrawer
